import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from 'src/marketConnect/helpers'

type LoginAsCustomerModalProps = {
  isVisible: boolean
  customerName?: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const CommonProceedAlertModal: FC<LoginAsCustomerModalProps> = ({
  isVisible,
  customerName = 'customer',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={isVisible} centered backdrop="static">
      <Modal.Body>
        <div className="text-center px-6 py-8">
          {/* Icon / Image */}
          <div className="mb-6">
            <KTSVG
              path="/media/icons/duotune/general/gen048.svg"
              className="svg-icon svg-icon-4hx svg-icon-primary"
            />
          </div>

          {/* Title */}
          <h3 className="fw-bold mb-3">
            Switch organization
          </h3>

          {/* Description */}
          <p className="text-muted mb-6">
           You are about to log in to <strong>Commercium Dashboard</strong>
           <br />in behalf of <strong>{customerName}</strong>
          </p>

          {/* Actions */}
          <div className="d-flex justify-content-center gap-4">
            <button
              className="btn btn-light px-6"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary px-6"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Proceed to Login'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default CommonProceedAlertModal
